import { ApiClientsError } from '#pplx/frontend/api-clients/core/errors.js';
import { getQueryTimeoutMs } from '#pplx/frontend/api-clients/core/utils.js';
import { webserveruserClient } from '#pplx_generated/typespec/rest/webserveruser/client.js';
export const getUserPromotions = async ({ reason, }) => {
    try {
        const { data, error, response } = await webserveruserClient.GET('/rest/user/promotions', reason, {
            timeoutMs: getQueryTimeoutMs({ productionMs: 2000 }),
        });
        if (error) {
            throw new ApiClientsError('API_CLIENTS_ERROR', {
                message: `Failed to fetch user promotions`,
                cause: error,
                status: response.status ?? 0,
            });
        }
        return data;
    }
    catch {
        return {
            campaign: undefined,
            offer: undefined,
            institution: undefined,
        };
    }
};
//# sourceMappingURL=getUserPromotions.js.map